export const ko = {
  common: {
    reserve: "좌석 예약",
    birthdayWall: "생일 보드",
    backHome: "홈으로",
    loading: "불러오는 중…",
    seatsLeft: "{n}석 남음",
    full: "마감",
    sets: "세트",
    guests: "명",
    person: "명",
    cancel: "취소",
    close: "닫기",
    submit: "보내기",
    required: "필수 입력",
    openMap: "지도 열기",
    minutes: "분",
    save: "저장",
  },
  nav: {
    schedule: "일정",
    giveaways: "사은품",
    notes: "안내 사항",
    faq: "자주 묻는 질문",
    location: "오시는 길",
    wall: "생일 보드",
    reserve: "예약",
  },
  hero: {
    badge: "HBD Bogummy · 16/6/2026",
    title: "Park Bo-gum 박보검\nHappy Birthday 2026",
    subtitle: "샌드위치 생일 파티를 함께 즐겨요",
    venue: "Gumm&Kalee Café에서",
    dateRange: "2026년 6월 14–16일",
    intro:
      "박보검 생일 기념 3일간의 특별 이벤트, 하루 3회차로 진행됩니다 — 예약 전에 안내를 모두 읽어 주세요.",
    cta: "지금 예약하기",
    ctaWall: "축하 메시지 남기기",
  },
  schedule: {
    title: "3일간의 일정",
    subtitle: "2026년 6월 14–16일 · 하루 3회차 · 회차 종료 시까지만 착석",
    roundWord: "회차",
    checkIn: "대기 확인",
    quotaBadgeN: "선착순 {n}세트 주문 시 스페셜 사은품",
    luckyBadge: "2세트 구매 시 경품 추첨",
    seeReserve: "이 회차 예약",
  },
  giveaway: {
    title: "사은품 & 경품",
    specialTitle: "스페셜 사은품",
    specialDesc:
      "각 회차에서 먼저 주문하신 분께 드리는 스페셜 사은품 — 6월 14일: 회차당 선착순 20세트, 6월 15·16일: 회차당 선착순 10세트 (현장에서의 주문 및 결제 순서로만 정해지며, 각 회차 30분 전에 현장에서 대기 번호표를 배부합니다. 사전 등록과는 무관합니다).",
    luckyTitle: "경품 추첨 (2세트 구매)",
    luckyDesc: "2세트를 구매하면 그날의 특별 경품 추첨에 응모할 수 있습니다.",
    perDayTitle: "날짜별 경품",
    shirt: "Be with You 정품 셔츠 1벌",
    ginseng: "에브리타임 홍삼 1박스 + 포스트카드",
    shampoo: "Dr.Forhair 샴푸 포켓몬 한정판",
    dayWord: "",
  },
  notes: {
    title: "방문 전 안내",
    items: [
      "각 회차 시작 30분 전부터 입장 확인이 가능합니다 (08:30 / 11:30 / 14:30).",
      "각 회차에 정시 도착을 부탁드립니다. 최대 30분까지 늦을 수 있으며, 그 이후에는 좌석이 취소되어 현장 워크인 손님에게 제공됩니다 (좌석이 남아 있는 경우).",
      "각 회차 참여자분은 해당 회차에 정해진 시간 내에서만 매장에 착석하고 활동에 참여해 주시기 바랍니다.",
      "샌드위치 생일 세트는 1인 1세트입니다 (좌석 수 = 세트 수).",
      "매장은 각 회차 종료 후 공간을 정리하여 다음 회차 참여자분이 매장을 이용하실 수 있도록 합니다.",
    ],
  },
  faq: {
    title: "자주 묻는 질문",
    items: [
      { q: "미리 예약해야 하나요?", a: "좌석 확보를 위해 예약을 권장합니다. 워크인은 회차 시작 30분 후 좌석이 남으면 입장 가능합니다." },
      { q: "좌석 예약이 스페셜 사은품과 관련 있나요?", a: "아니요. 각 회차 좌석 예약은 매장 내부 운영과 참여자분의 편의를 위한 것일 뿐이며, 샌드위치 세트 주문이나 스페셜 사은품 수령과는 관련이 없습니다." },
      { q: "예약 한 건당 몇 좌석인가요?", a: "참여 인원(= 세트 수)을 원하는 만큼 입력하세요. 1세트당 1명입니다." },
      { q: "예약 비용이 있나요?", a: "좌석 예약에는 어떠한 비용이나 보증금도 없습니다. 매장이 각 회차 참여 인원을 파악하고 충분한 물량을 준비할 수 있도록 좌석을 확보해 두는 것일 뿐입니다." },
      { q: "예약 변경/취소는 어떻게 하나요?", a: "확인 이메일의 링크로 예약을 확인하거나 취소할 수 있습니다. 취소 시 좌석은 즉시 반환됩니다." },
      { q: "확인 이메일을 못 받았어요.", a: "스팸함을 확인하거나 화면의 예약 코드를 저장해 두세요. 스태프에게 재발송을 요청할 수 있습니다." },
    ],
  },
  location: {
    title: "오시는 길",
    cafe: "Gumm&Kalee Café",
    desc: "Google 지도에서 길찾기와 위치를 확인하세요.",
    button: "Google 지도에서 열기",
  },
  reserve: {
    title: "좌석 예약",
    subtitle: "정보를 입력해 예약하세요. 확인 이메일을 보내드립니다.",
    name: "이름",
    phone: "전화번호",
    email: "이메일",
    emailHint: "예약 확인 이메일 수신용",
    partySize: "참여 인원 (세트)",
    day: "날짜 선택",
    round: "회차 선택",
    pickDayFirst: "먼저 날짜를 선택하세요",
    submit: "예약 확정",
    submitting: "예약 중…",
    selectRound: "— 회차 선택 —",
    maxPartyNote: "예약당 최대 {n}명",
    errors: {
      name: "이름을 입력하세요",
      phone: "올바른 전화번호를 입력하세요",
      email: "올바른 이메일을 입력하세요",
      slot: "날짜와 회차를 선택하세요",
      turnstile: "로봇이 아님을 확인해 주세요",
      full: "죄송합니다. 이 회차는 마감되었습니다. 다른 회차를 선택하세요.",
      generic: "오류가 발생했습니다. 다시 시도해 주세요.",
    },
    successTitle: "예약 완료!",
    successDesc: "확인 이메일을 보냈습니다. 예약 코드를 저장해 주세요.",
    yourCode: "예약 코드",
    emailSent: "확인 이메일을 보냈습니다",
    emailSkipped: "이메일이 아직 활성화되지 않았습니다 — 코드를 저장해 주세요.",
    emailFailed: "이메일 발송 실패 — 코드를 저장하고 스태프에게 문의하세요.",
    manageLink: "예약 관리 / 취소 링크",
    reserveAnother: "다시 예약",
    screenshotTip: "당일 제시를 위해 QR을 저장하거나 화면을 캡처하세요.",
    saveImage: "QR 이미지 저장",
    qrHint: "이 QR을 스캔하거나 저장해 예약을 확인하세요.",
  },
  manage: {
    title: "내 예약",
    status: "상태",
    confirmed: "확정됨",
    cancelled: "취소됨",
    cancelBtn: "예약 취소",
    cancelling: "취소 중…",
    cancelConfirm: "이 예약을 취소할까요? 좌석은 다른 분께 반환됩니다.",
    cancelledMsg: "예약이 취소되었습니다. 감사합니다!",
    notFound: "예약을 찾을 수 없습니다 — 링크가 올바르지 않을 수 있습니다.",
  },
  wall: {
    title: "생일 축하 보드",
    subtitle: "박보검에게 사진이나 메시지를 보내세요. 스태프 확인 후 매장 보드에 표시됩니다.",
    nameLabel: "이름 (선택)",
    messageLabel: "축하 메시지",
    photoLabel: "사진 첨부 (선택)",
    choosePhoto: "사진 선택",
    post: "메시지 보내기",
    posting: "보내는 중…",
    pendingMsg: "전송 완료! 스태프 확인 후 보드에 표시됩니다.",
    emptyErr: "메시지나 사진을 추가하세요.",
    emptyGallery: "아직 표시된 메시지가 없습니다 — 첫 번째 주인공이 되어 보세요!",
    galleryTitle: "최근 메시지",
    seeAll: "모든 메시지 보기",
    rateLimited: "너무 자주 보내고 있습니다. 잠시 기다려 주세요.",
    tooLarge: "이미지 파일이 너무 큽니다.",
  },
  wishes: {
    title: "모든 메시지",
    sortLatest: "최신순",
    sortLiked: "좋아요순",
    empty: "아직 표시된 메시지가 없습니다 — 첫 번째 주인공이 되어 보세요!",
    end: "마지막까지 모두 보셨어요 💛",
    likeRateLimited: "좋아요가 너무 많습니다. 잠시 기다려 주세요.",
  },
  admin: {
    title: "Admin · 이벤트 콘솔",
    password: "비밀번호",
    login: "로그인",
    loggingIn: "로그인 중…",
    badPassword: "비밀번호가 올바르지 않습니다",
    logout: "로그아웃",
    tabStats: "좌석 현황",
    tabReservations: "예약",
    tabWall: "보드 검수",
    tabTools: "도구",
    totalBookings: "총 예약 수",
    totalGuests: "총 참여 인원",
    slot: "회차",
    booked: "예약됨",
    remaining: "여석",
    capacity: "정원",
    bookings: "건",
    quota: "사은품 한도",
    search: "이름/전화/이메일/코드 검색",
    filterSlot: "전체 날짜/회차",
    exportCsv: "CSV 다운로드",
    name: "이름",
    phone: "전화",
    email: "이메일",
    size: "세트",
    status: "상태",
    emailStatus: "이메일",
    actions: "관리",
    resend: "이메일 재발송",
    save: "저장",
    edit: "수정",
    pending: "검수 대기",
    approved: "승인됨",
    rejected: "거부됨",
    approve: "승인",
    reject: "거부",
    noPending: "검수 대기 중인 게시물이 없습니다",
    wallQrTitle: "생일 보드 QR",
    wallQrDesc: "매장에 출력해 두면 손님이 스캔해 메시지를 남길 수 있습니다.",
    boardLink: "보드 화면 열기 (스크린용)",
    downloadQr: "QR 다운로드",
    boardSettings: "보드 화면 설정",
    boardSettingsDesc: "단일 카드 모드와 카드 월 모드 전환 시간을 설정합니다.",
    boardCardMinutes: "단일 카드 모드 (분)",
    boardWallMinutes: "카드 월 모드 (분)",
    boardCardAdvance: "카드 전환 간격 (초)",
    saveSettings: "설정 저장",
    settingsSaved: "저장됨",
  },
  board: {
    empty: "첫 번째 메시지를 기다리고 있어요… QR을 스캔해 마음을 전해 주세요.",
    scanToPost: "스캔하여 메시지 남기기",
  },
  footer: {
    unofficial: "비공식 팬 메이드 이벤트",
    developedBy: "개발",
  },
} as const;
